import { cn } from '@/lib/cn';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  id?: string;
  disabled?: boolean;
  className?: string;
}

export default function Switch({
  checked,
  onChange,
  label,
  id,
  disabled = false,
  className,
}: SwitchProps) {
  return (
    <label
      className={cn(
        'inline-flex items-center gap-2.5',
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        className,
      )}
      htmlFor={id}
    >
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cn(
          'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-all duration-200 ease-smooth cursor-pointer disabled:cursor-not-allowed',
          checked ? 'bg-accent-500 border-accent-500 shadow-xs' : 'bg-background-200 border-background-300 hover:border-background-400',
        )}
      >
        <span
          className={cn(
            'absolute top-1/2 h-[18px] w-[18px] -translate-y-1/2 rounded-full bg-background-50 shadow-sm transition-transform duration-200 ease-smooth',
            'start-[2px]',
            checked ? 'translate-x-[22px] rtl:-translate-x-[22px]' : 'translate-x-0',
          )}
        />
      </button>
      {label ? <span className="text-sm font-medium text-foreground-800">{label}</span> : null}
    </label>
  );
}